import { Theme } from '@cambridgeassessment/cambridge-ui';
import { makeStyles } from '@material-ui/core';

interface AccountCardStylesProps {
  hasOrganisations?: boolean;
  isXs?: boolean;
}

export const useStyles = makeStyles((theme: Theme) => ({
  helloMessage: {
    marginBottom: ({ isXs }: AccountCardStylesProps) => (isXs ? 6 : 0),
    wordWrap: 'break-word',
  },
  organisationPanel: {
    display: 'flex',
    alignItems: ({ isXs }: AccountCardStylesProps) =>
      isXs ? 'flex-start' : 'center',
    flexDirection: ({ isXs }: AccountCardStylesProps) =>
      isXs ? 'column' : 'row',
    marginTop: ({ hasOrganisations }: AccountCardStylesProps) =>
      hasOrganisations ? 2 : 12,
    marginBottom: ({ hasOrganisations }: AccountCardStylesProps) =>
      hasOrganisations ? -10 : 0,
    '& > .MuiTypography-root': {
      lineHeight: '1.5',
      fontSize: '1.14em',
      paddingRight: 24,
      borderRight: ({ hasOrganisations, isXs }: AccountCardStylesProps) =>
        hasOrganisations && !isXs && `1px solid ${theme.palette.neutral[50]}`,
    },
    '& > .MuiButtonBase-root': {
      marginLeft: ({ isXs }: AccountCardStylesProps) => (isXs ? -16 : 8),
      marginTop: ({ isXs }: AccountCardStylesProps) => (isXs ? 8 : 0),
    },
  },
}));
